import { Box, Typography } from "@mui/material";
import React, { useState } from "react";

interface ColorVariant {
  name: string;
  hex: string;
  retail_price: number;
  wholesale_price: number;
  is_default?: boolean;
}

interface ColorVariantSelectorProps {
  colorVariants: ColorVariant[];
  onVariantSelect: (variant: ColorVariant) => void;
  selectedVariant?: ColorVariant;
  dealerSwitch: boolean;
}

export default function ColorVariantSelector({
  colorVariants,
  onVariantSelect,
  selectedVariant,
  dealerSwitch,
}: ColorVariantSelectorProps & { colorVariants: ColorVariant[] }) {

  const getInitialVariant = (): ColorVariant | null => {
    // Find the first variant with is_default true
    const defaultVariant = colorVariants.find((v: ColorVariant) => v.is_default === true);
    if (defaultVariant) return defaultVariant;

    // If none, fallback to the first variant
    return colorVariants[0] ?? null;
  };

  const [selected, setSelected] = useState<ColorVariant | null>(
    selectedVariant ?? getInitialVariant()
  );

  const handleVariantSelect = (variant: ColorVariant) => {
    setSelected(variant);
    onVariantSelect(variant);
  };

  if (!colorVariants || colorVariants.length === 0) {
    return null;
  }

  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        variant="h6"
        sx={{
          color: "#666666",
          fontSize: "18px",
          fontWeight: "500",
          mb: 2,
        }}
      >
        Color Options
      </Typography>

      <Box sx={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
        {colorVariants.map((variant, index) => (
          <Box
            key={variant.hex}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              cursor: "pointer",
              // border: selected?.hex === variant.hex ? "2px solid #00E852" : "2px solid transparent",
              // borderRadius: 2,
              // p: 0.5,
              transition: "all 0.2s ease",
              "&:hover": {
                borderColor: "#00E852",
                transform: "translateY(-2px)",
              },
            }}
            onClick={() => handleVariantSelect(variant)}
          >
            <Box
              sx={{
                width: 20,
                height: 20,
                borderRadius: "50%",
                bgcolor: variant.hex,
                border: "2px solid #ddd",
                mb: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
              }}
            >
              {selected?.hex === variant.hex && (
                <Box
                  sx={{
                    position: "absolute",
                    top: -5,
                    right: -5,
                    width: 8,
                    height: 8,
                    borderRadius: "50%",
                    bgcolor: "#00E852",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    fontSize: "8px",
                    fontWeight: "bold",
                    padding: '3px',
                  }}
                >
                  ✓
                </Box>
              )}
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
} 